import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=1d2c7f77"
import script from "./MessageTemplate.vue?vue&type=script&lang=js"
export * from "./MessageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports